module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("The first law of the historian is that he shall never dare utter an untruth.")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "fmcenter"
  }, [_vm._v("The second is that he shall suppress nothing that is true.")]), _vm._v(" "), _c('p', {
    staticClass: "fmcenter"
  }, [_vm._v("Moreover, there shall be no suspicion of partiality in his writing, or of malice.")]), _vm._v(" "), _c('p', {
    staticClass: "fmcenter"
  }, [_vm._v("— Cicero")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16eacb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 57
// module chunks = 0